import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';
import { DriverProperty } from '../../../types';
import { L } from 'harmony-language';

export const useDriverPropertyColumns = () => {
    const columnHelper = createColumnHelper<DriverProperty>();

    const columns = React.useMemo(() => ([
        columnHelper.accessor('name', {
            header: L.name(),
            cell: (info) => info.getValue(),
            enableColumnFilter: false,
        }),
    ]), []);

    return columns;
}